import { render, staticRenderFns } from "./lookback.vue?vue&type=template&id=531b5096&scoped=true&"
import script from "./lookback.vue?vue&type=script&lang=js&"
export * from "./lookback.vue?vue&type=script&lang=js&"
import style0 from "./lookback.vue?vue&type=style&index=0&id=531b5096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531b5096",
  null
  
)

export default component.exports